import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import React from "react";
const STATUS_CLASS = "c-suggestion-status";

const ErrorToolCallSuggestion = (handleRetry) => {
    return (
        <>
            <div className={`${STATUS_CLASS} -errored`}>
                <span>I was unable to create the new checklist.</span>
                <span className={`${STATUS_CLASS}__separator`}>&middot;</span>
                <Button
                    onClick={handleRetry}
                    size={ButtonSizes.Small}
                    style={ButtonStyles.Text}>
                    Try Again
                </Button>
            </div>
            <div style={{ height: "4px" }} />
        </>
    );
};

export default ErrorToolCallSuggestion;
